import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "icon", "message"]

  connect() {
    // 초기 상태는 숨김
    this.containerTarget.style.display = "none"
  }

  show(event) {
    // 이벤트 객체에서 메시지와 타입 추출
    const { message, type = 'info' } = event.detail || {}
    
    this.iconTarget.className = `toast__icon fas ${this.getIconClass(type)}`
    this.messageTarget.textContent = message
    this.containerTarget.style.display = "block"
    this.containerTarget.classList.add('toast__container--show')

    setTimeout(() => {
      this.hide()
    }, 3000)
  }

  hide() {
    this.containerTarget.classList.remove('toast__container--show')
    setTimeout(() => {
      this.containerTarget.style.display = "none"
    }, 300)
  }

  getIconClass(type) {
    switch (type) {
      case 'success':
        return 'fa-check-circle'
      case 'error':
        return 'fa-exclamation-circle'
      default:
        return 'fa-info-circle'
    }
  }
} 